import { Inject, Injectable, ViewChild } from '@angular/core';

import { forkJoin, from, concat, Observable, firstValueFrom, switchMap, throwError, tap, lastValueFrom } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { PageHelper } from './PageHelper';

import { MyService } from './MyService';
import { AuthService, UserProfile } from './auth-service';
import { ResultVO } from './vo/CommonVO';
import { AlertController, Platform } from '@ionic/angular';
import { App } from '@capacitor/app';
import { StorageService } from './storage-service';
import { GoService } from './go-service';
import { map } from 'jquery';
import { GlobalVarService } from './globalvar-service';


@Injectable()
export class AppInitService {

    constructor(private myService: MyService,
        private goService: GoService,
        private pageHelper: PageHelper,
        private log: NGXLogger,
        private authService: AuthService,
        private platform: Platform,
        private alertCtrl: AlertController,
        private storageServie: StorageService,
        private globalVarService:GlobalVarService
    ) {
    }

    load(): Promise<any> {
        return (firstValueFrom(this.doInit()));
    }

    /**系統初始可以寫在這 */
    doInit(): Observable<any> {

        return this.doDeviceLogin();
    }
    doDeviceLogin(): Observable<void> {

        return (this.pageHelper.getUUid().pipe(
            tap(uuid => {
                //補捉是否可安裝
                addEventListener("beforeinstallprompt",(e)=>{                  
                    this.onbeforeinstallprompt(e);
                })

                if (uuid) {
                    this.storageServie.set("uuid", uuid);
                } else {
                    throwError(() => { new Error('uuid為空') });
                }
            }),
            switchMap((uuid) => {
                return (this.goService.DoPost("DeviceLogin", { UUID: uuid }).pipe(
                    switchMap(resultVO => {
                        if (resultVO.result) {
                            return from(this.dologin(resultVO, uuid));
                        } else {
                            this.log.error("DeviceLogin error " + uuid);
                            throwError(() => { new Error('DeviceLogin error :' + uuid) });
                        }
                    })
                ));
            }
            )
        ))
    }

    private async dologin(res: ResultVO, uuid: string) {
        var u = new UserProfile();
        u.userId = res.data.UserId;
        u.email = res.data.Email;
        u.userName = res.data.Name;
        u.accessToken = res.data.Tokens.accessToken;
        u.refreshToken = res.data.Tokens.refreshToken;
        u.fackbookID = res.data.FackbookID;
        u.googleID = res.data.GoogleID;
        u.uuid = uuid;
        await this.authService.login(u);
        this.log.trace("登入帶的資訊", u);
    }

    onbeforeinstallprompt(e) {
        console.log(">>>>>>catch beforeinstallprompt >>>>>>>");
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        this.globalVarService.setIsInstalledApp(false);
        this.globalVarService.setInstallEvent(e);
      }
}